
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function WatchesPage() {
  useEffect(() => {
    updateSEO({
      ...seoData.watches,
      canonical: `${getBaseURL()}/watches`,
      ogTitle: seoData.watches.title,
      ogDescription: seoData.watches.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Relevância');

  const filters = ['Todos', 'Rolex', 'Omega', 'Cartier', 'Patek Philippe', 'Audemars Piguet'];
  const sortOptions = ['Relevância', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/b230c916d7eb01d78704bae4f86957a4.jpg',
      brand: 'DLUXMEN',
      name: 'Relógio Premium Swiss',
      price: 'R$ 899,90',
      originalPrice: 'R$ 1.199,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20chronograph%20watch%20premium%20materials%20with%20sophisticated%20dial%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20chronograph%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-chrono-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Cronógrafo Luxury Edition',
      price: 'R$ 1.299,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20dress%20watch%20premium%20gold%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20dress%20watch%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20materials&width=400&height=500&seq=dluxmen-dress-watch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Relógio Social Gold',
      price: 'R$ 1.599,90',
      originalPrice: 'R$ 1.999,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20sport%20watch%20premium%20steel%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20sport%20watch%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-sport-watch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Relógio Esportivo Premium',
      price: 'R$ 799,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20automatic%20watch%20premium%20movement%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20automatic%20watch%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-auto-watch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Automático Premium',
      price: 'R$ 1.099,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20skeleton%20watch%20premium%20mechanism%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20skeleton%20watch%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-skeleton-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Skeleton Luxury Edition',
      price: 'R$ 1.799,90',
      originalPrice: 'R$ 2.299,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20vintage%20watch%20premium%20design%20with%20sophisticated%20retro%20style%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20vintage%20watch%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-vintage-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Vintage Premium Collection',
      price: 'R$ 949,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20diamond%20watch%20premium%20materials%20with%20sophisticated%20gem%20setting%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20diamond%20watch%20with%20emerald%20green%20brand%20details%2C%20high-end%20luxury&width=400&height=500&seq=dluxmen-diamond-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Diamond Luxury Edition',
      price: 'R$ 2.499,90',
      originalPrice: 'R$ 2.999,90'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Watches
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Relógios premium com movimento suíço e design sofisticado
          </p>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
